import { AxiosResponse } from 'axios';
import { DataCertificateConformity } from 'civil-status/view-models/data-certificate-conformity';
import { SignatureActUscVM } from 'civil-status/view-models/step-form';
import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';
import { HttpResponse } from 'shell/models/http-response';

export const transformerCertificateConformity = (
  response: AxiosResponse<HttpResponse<DataCertificateConformity>>
): SignatureActUscVM => {
  const castedResponseEvento = response.data?.payload?.evento || {};
  const castedAnteprimaAttestazioneResponse =
    response.data.payload.anteprimaAttestazioneResponse || {};
  const castedResponseOperatoreUsc = response.data?.payload?.operatoreUsc || {};

  return {
    idAnsc: castedResponseEvento.idAnsc || '',
    idState: castedResponseEvento.codiceStatoEvento || '',
    otp: '',
    pin: '',
    user: castedResponseOperatoreUsc.codiceFirma || '',
    operatorName: castedResponseEvento.operatoreNome || '',
    operatorSurname: castedResponseEvento.operatoreCognome || '',
    document: castedAnteprimaAttestazioneResponse.allegatoOutput
      ? ({
          raw: castedAnteprimaAttestazioneResponse.allegatoOutput.contenuto || '',
          name: castedAnteprimaAttestazioneResponse.allegatoOutput.nomefile || '',
          type: castedAnteprimaAttestazioneResponse.allegatoOutput.tipoFile || '',
        } as TypeFile)
      : undefined,
  };
};
